import { combineReducers } from "redux";

import auth from "domain/core/auth/reducer";
import app from "domain/core/app/reducer";

export default combineReducers({
  auth,
  app
});
